import React, { useEffect } from 'react'
import Aos from "aos"


export default function TeamCard({title,designation,img,delay}) {
  useEffect(() => {
    window.addEventListener("DOMContentLoaded" , () => {
      setTimeout(() => {
        Aos.refresh();
      }, 500);
    })
    Aos.init({duration:1000});
  })
  return (
    <>
      <div className="teamCard" data-aos="fade-up"  data-aos-delay={delay}>
        <figure>
            <img src={img} alt="" />
        </figure>
        <div className="cardDetails">
            <h2>{title}</h2>
            <p>{designation}</p>
            <div className="social">
            <i className="fa-brands fa-twitter"></i>
            <i className="fa-brands fa-facebook-f"></i>
            <i className="fa-brands fa-linkedin"></i>
            </div>
        </div>
      </div>
    </>
  )
}
